import React, { useEffect, useRef, useState } from 'react'
import { useStateFields } from '../../store/hooks';
import './Navbar.css'
import Sidebar from '../Sidebar/Sidebar'
import { token_url, get_logo, get_platform_bg_color, getAuthToken, getAPIUrl, get_platform_action_color, globalLoader, isAdmin } from '../../script/util'
import { IoArrowBack } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Popup from '../Popup/Popup';
import axios from 'axios'
import { portfolio } from '../../context/workConstants';
import { openExternalApp } from '@egreact/shared';

const Navbar = ({ title, location, loggedIn }) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [event, setEvent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [callbackMessage, setCallbackMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(true);
  const [coinBalance, setCoinBalance] = useState(null);
  const upload = useRef(false)
  const { isOpen, setisOpen } = useStateFields(['isOpen']);
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  let left;
  if (location && location === token_url(`${process.env.REACT_APP_STAG_URL}`)) {
    const isMobileApp = JSON.parse(localStorage.getItem('auth_dict'))?.is_mobile_app;
    left = <Link to={title == 'Dashboard' && isMobileApp ? '/' : location}><img className='logoSize' src={get_logo(true)}/></Link>;
  } else {
    if(title != portfolio){
      left = <Link to='/'><IoArrowBack /></Link>;
      upload.current = true
    }

  }

  const WEDDING = "Wedding";
  const CORPORATE = "Corporate";
  const ENGAGEMENT_ROKA = "Engagement/Roka";
  const PRE_WEDDING = "Pre Wedding";
  const OTHER = "Other";

  useEffect(() => {
    initializeCallback();
  }, []);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const res = await fetch(getAPIUrl('/api/payment/v2/wallet/'), {
          headers: { Authorization: getAuthToken() },
        });
        const data = await res.json();
        if (data.balance_coins != null) setCoinBalance(data.balance_coins);
      } catch {}
    };
    fetchBalance();
  }, []);

  useEffect(() => {
    if (isPopupOpen) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }

    return () => {
      document.body.style.overflowY = "auto";
    };
  }, [isPopupOpen]);

  const navigate = useNavigate();
  const handleBackPress = () => {
    navigate(`/?id=${id}`)
  };

  const profileName = () => {
    const nameInitial = JSON.parse(localStorage.getItem('auth_dict'))?.eventGraphiaInitials
    return nameInitial
  }

  const initializeCallback = () => {
    setSuccess(false);
    setErrorMessage("");
    setShowAdditionalDetails(true);
    setIsLoading(false);
  };

  const handleCallbackRequest = async (e) => {
    if(!isAdmin()){
      e.preventDefault();
      setShowAdditionalDetails(false);
      setIsLoading(true);

      if (!event) {
        setErrorMessage("Please enter event details");
        setShowAdditionalDetails(true);
        setIsLoading(false);
        return;
      }


      try {
        const currentReactPath = window.location.href;
        const response = await axios.post(
          getAPIUrl("/api/meeting/callback/"),
          {    event: event,            
              react_path: currentReactPath,  },
          {
            headers: {
              "Authorization": getAuthToken(),
            },
          }
        );

        if (response.data.success) {
          setCallbackMessage(response.data.message);
          setSuccess(true);
        } else {
          setErrorMessage(response.data.message);
          setShowAdditionalDetails(false);
        }
      } catch (err) {
        setErrorMessage("Failed to connect to the server");
        setShowAdditionalDetails(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const closePopup = () => {
    setSuccess(false);
    setErrorMessage("");
    setShowAdditionalDetails(true);
    setEvent("");
    setIsLoading(false);
    setPopupOpen(false);  
  }

  return (
    <>
      <div className="navbar">
        {!upload.current && title!= portfolio && <div className="nav-left" onClick={handleBackPress}>{left}</div>}
        {(upload.current || title == portfolio) && <div className='nav-left' ><Link to='/'><img className='logoSize' src={get_logo(true)} /></Link></div>}
        {/* <div className="nav-middle">{title}</div> */}
        <div className="nav-right">
          <div className='connectDiv'>
            <p style={{ paddingRight: "20px", cursor: "pointer",}}>
              <a style={{ display:"flex", alignItems:"center" }} target='_blank' onClick={() => openExternalApp(`https://www.instagram.com/${process.env.REACT_APP_PLATFORM}/`)}>
                <span className='brandIcon'>
                  <FontAwesomeIcon icon={faInstagram} size={window.innerWidth < 600 ? 'xl' : "sm"} style={{ color: "#000000", paddingRight:"5px"}} />
                </span>
                <span style={{ fontSize: window.innerWidth < 1200 ? (window.innerWidth<600 ? '12px' : '15px') : '18px' }} className='navBrandText'> {" "}Follow</span>
              </a>
            </p>
            <div
              style={{ paddingRight: "20px", cursor: "pointer", display:"flex", alignItems:"center" }}>
              <p onClick={() => setPopupOpen(true)} style={{ display:"flex", alignItems:"center", margin: 0 }}>
              <span className='brandIcon'>
                <FontAwesomeIcon 
                  icon={faPhone} 
                  size={window.innerWidth < 600 ? 'xl' : "sm"} 
                  style={{ color: "#000000", paddingRight:"5px"}} 
                />
              </span>
              <span 
                className='navBrandText' 
                style={{ fontSize: window.innerWidth < 1200 ? (window.innerWidth<600 ? '12px' : '15px') : '18px', whiteSpace: 'nowrap' }}
              >
                {" "}{title == portfolio ? "Request a Callback" : "Book Us"}
              </span>
             </p>
            </div>
          </div>
          {title!==portfolio && title!=='quoteForm' && (title!=='Referral' || loggedIn) && (
            <div className='profile-coin-pill'>
              <div
                className='profile-coin-pill__avatar'
                style={{ background: get_platform_bg_color(), border: `1px solid ${get_platform_bg_color()}` }}
                onClick={() => setisOpen(true)}
              >
                {profileName()}
              </div>
              {coinBalance !== null && (
                <Link to="/wallet" className='profile-coin-pill__balance' onClick={e => e.stopPropagation()}>
                  <span className='profile-coin-pill__icon'>EG</span>
                  <span style={{ fontWeight: 900 }}>{coinBalance}</span>
                </Link>
              )}
            </div>
          )}

        </div>
      </div>
      {
        isOpen && <Sidebar />
      }
      {isPopupOpen && (
        <Popup 
          onClose={() => closePopup()} 
          isOpen={isPopupOpen}
        >

        {
        isLoading && (<div id='acc-form'>
          {globalLoader()}
        </div>)
        }

        {
          showAdditionalDetails && !success && !errorMessage && (
            <div className="five pockets" id="acc-form"  style={{ paddingLeft: '2rem', paddingRight: '2rem' }}  >
            <h1 style={{ textAlign: "center", paddingTop: 10 }} className='accountDetailHead'>Which event do you want to book?
            </h1>
<div className="form-el" style={{ position: 'relative', marginBottom: '20px', textAlign: 'left' }}>
              
              <input
                type="text"
                placeholder="Event & Date *"
                value={event}
                onChange={(e) => setEvent(e.target.value)}
                autoFocus
                required
                style={{ width: '100%', padding: '12px 40px 12px 15px', boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff', position: 'relative', zIndex: 2 }}
              />
            </div>
            <div className="form-el callback_btn">
              <button
                id="request-callback"
                className="book-prc-btn"
                style={{ backgroundColor: get_platform_action_color(), color: "#fff" }}
                onClick={handleCallbackRequest}
              >
                Request Callback
              </button>
            </div>
        </div>

          )
        }

        {
          success && !showAdditionalDetails && (
            <div id='acc-form' className='additional-details'>
              <div className="successbox">
                <div className='heading-line'></div>
                <h1 className='success'>SUCCESS!</h1>
                <div className='heading-line'></div>
              </div>
              <h2 style={{ textAlign: "center", paddingTop: 10 }} className='message'>
                {callbackMessage}
              </h2>
            </div>
          )
        }

        {
          errorMessage && !showAdditionalDetails && (
            <div id='acc-form'>
              <div className="successbox">
                <div className='heading-line error'></div>
                <h1 className='error'>ERROR!</h1>
                <div className='heading-line error'></div>
              </div>
              <h2 style={{ textAlign: "center", paddingTop: 10}}  className='message'>
                {errorMessage}
              </h2>
            </div>
          )
        }

        </Popup>
    ) }
    </>
  )
}

export default Navbar